import { appStore } from '../../app/AppStore';
import { Module } from '../Module';

interface IAppAdminStateScope extends ng.IScope {
  displayDefault: boolean;
  displayInnerApp: boolean;
}

Module.instance().directive('tbApp', [
  () => {
    return ({
      restrict: 'E',
      replace: true,
      template: '<div class="tb-app-inner"><tb:app-inner ng-if="displayInnerApp"/><div ng-if="displayDefault"><tb:root-space-router /></div><div ng-if="displayDefault"><tb:navigation-telemetry /></div></div>',
      scope: {},
      link: (scope: IAppAdminStateScope) => {
        function updateDisplayDefault() {
          const rootAdminUiState = appStore.getState().rootAdminUiState;
          scope.displayDefault = rootAdminUiState === 'default';
          scope.displayInnerApp = rootAdminUiState !== 'default' && rootAdminUiState !== 'bootstrap';
        }
        updateDisplayDefault();
        appStore.subscribe(() => {
          updateDisplayDefault();
        });
      }
    });
  }
]);
